export default __webpack_public_path__ + "static/media/hasura.9b298fc1.svg";